import { getCategoryHref } from '../../utils/common/category';
import { CONTENT_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'contentIdeaGeneratorType',
      analyticsName: 'content_idea_type',
      textLabel: 'Generate content ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: CONTENT_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Content',
        value: getCategoryHref(CONTENT_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'contentIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'content_ideas_generator',
      placeholder: 'Try "videos for my healthy food blog" or "Instagram stories for shoe brand"',
      textLabel: 'Describe what you need ideas for',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: CONTENT_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
